import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { usePassengersMapBulkActions, useSelectedIds } from "@ryde/redux";
import {
  passengerGridMapOpenAtom,
  PASSENGERS_MAP_DEFAULT_FILTER_TYPE,
  TOOLTIP_DELAY_BUTTONS,
} from "@ryde/shared";
import { deepPurpleMui, greyMui } from "@ryde/theme";

import { MapToggleButtonStyled } from "./elements.styled";

export const PassengersMapToggleButton: FC = () => {
  const { t } = useTranslation();
  const [mapOpen, setMapOpen] = useRecoilState(passengerGridMapOpenAtom);
  const { selectedRowsIds } = useSelectedIds();
  const { bulkFetchPassengersStationMapData } = usePassengersMapBulkActions();

  const fetchStationOnInit = useEvent(async (): Promise<void> => {
    await bulkFetchPassengersStationMapData({
      filterType: PASSENGERS_MAP_DEFAULT_FILTER_TYPE,
      selectedPassengersIds: selectedRowsIds,
    });
  });

  const onClick = useEvent((): void => {
    // fetch on first open
    if (!mapOpen) {
      fetchStationOnInit();
    }

    setMapOpen(prevState => !prevState);
  });

  const color = mapOpen ? deepPurpleMui.A700 : greyMui._600;

  return (
    <FramerTooltip
      content={t("ui.TOGGLE_MAP")}
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <MapToggleButtonStyled onClick={onClick}>
        <SVG_MUI.MapToggle4SVG fill={color} className="MapToggleButtonSVG" />
        <label style={{ color }}>{t("ui.MAP")}</label>
      </MapToggleButtonStyled>
    </FramerTooltip>
  );
};
